import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useClassName } from 'common/hooks';
import { track } from 'utils/analytics';
import { useWindowSize } from 'common/hooks';

import Video from './Video';

import './player.less';
import YouTubePlayer from './YoutubePlayer';

function getHeightFromWidth(width) {
  const aspectRatio = 9 / 16;
  return width * aspectRatio;
}

function isYouTubeVideoLink(url) {
  const regex =
    /^https?:\/\/(?:www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}$/;
  return regex.test(url);
}

const Player = ({ id, name, videoUrl, posterUrl, controls }) => {
  const className = useClassName('Player');
  const [isPlaying, setIsPlaying] = useState(false);
  const { width, isDesktop } = useWindowSize();

  const play = (id, name, evt) => {
    evt.preventDefault();
    if (isYouTubeVideoLink(videoUrl)) {
      if (!isPlaying) {
        setIsPlaying(true);
        track('Video Play', { label: name });
      }
    } else {
      const video = document.getElementById(id);
      if (!video) return null;

      if (isPlaying) {
        setIsPlaying(false);
        video.pause();
      } else {
        setIsPlaying(true);
        video.controls = true;
        video.play();

        track('Video Play', { label: name });

        video.onended = () => {
          track('Video Ended', { label: name });
        };
      }
    }
  };

  if (isYouTubeVideoLink(videoUrl)) {
    const iFrameWidth = isDesktop ? 700 : width - 48;
    const iFrameHeight = getHeightFromWidth(isDesktop ? 700 : width - 48);

    return (
      <div
        className={className('container')}
        onClick={(evt) => play(id, name, evt)}>
        {iFrameWidth && iFrameHeight && (
          <YouTubePlayer
            width={iFrameWidth}
            height={iFrameHeight}
            url={videoUrl}
            trigger={
              <img
                src={posterUrl}
                width={iFrameWidth}
                height={iFrameHeight}
                style={{
                  borderRadius: '16px',
                }}
              />
            }
          />
        )}
      </div>
    );
  }

  return (
    <div
      className={className('container')}
      onClick={(evt) => play(id, name, evt)}>
      <Video
        src={videoUrl}
        id={id}
        poster={posterUrl}
        preload="metadata"
        controls={controls}
        controlsList="nodownload"
        width="100%"
        height="100%"
        className={className('video')}
      />
    </div>
  );
};

Player.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  posterUrl: PropTypes.string.isRequired,
  controls: PropTypes.bool.isRequired,
};

export default Player;
